import { ApiResponse } from '../@types';
import { request } from '../../utils';

const apiStatusCheck = async (): Promise<ApiResponse<string>> => {
  return request<ApiResponse<string>>({
    url: 'status',
    method: 'GET',
  });
};

export default apiStatusCheck;
